/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
import { ApiService, UserService } from '../services';
import { Injectable } from '@angular/core';
import { ModulesEnum, OtherEnum, TokenStatus } from '../enums';

@Injectable()
export class PreAuthGuard {

    constructor(
        private api: ApiService,
        private user: UserService) {
    }

    public canActivate() {
        if (this.user.hasLocalStorage()) {
            if (this.user.tokenStatus() === TokenStatus.OK || this.user.tokenStatus() === TokenStatus.REFRESH) {
                return this.checkHost().then(() => {
                    return true;
                }, () => {
                    return false;
                });
            }
        }
        this.user.logout();

        return false;
    }

    /**
     * Function used to ensure that we can still communicate with the host
     * Otherwise handle the situation.
     */
    public checkHost() {
        return new Promise<void>((connected, disconnected) => {
            this.api.ping(OtherEnum.GET_PING, ModulesEnum.LOADBALANCER, 2000).subscribe({
                next: alive => {
                    if (alive) {
                        connected();
                    } else {
                        this.user.logout();
                        disconnected();
                    }
                }
            });
        });
    }
}
